<div class="table-responsive">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex align-items-center justify-content-between mt-3 mb-3" style="padding-left: 1%;">
            <h2 style="margin-bottom: 0;">Escrow Accounts</h2>
            <div class="button-items d-flex align-items-center" style="gap: 8px;">
              <button class="btn btn-primary btn-sm" (click)="loadEscrowAccounts(lastTableLazyLoadEvent)"
                pTooltip="Refresh table" appActionTooltip><i class="mdi mdi-reload"></i></button>
                <button class="btn btn-primary btn-sm" (click)="dt.clear()"
                  pTooltip="Clear all column filters" appActionTooltip>Clear <i
                class="mdi mdi-filter-remove"></i></button>
                <button class="btn btn-success btn-sm" (click)="addEscrowAccount()"
                  pTooltip="Add a new escrow account" appActionTooltip><i class="mdi mdi-plus"></i> Add Escrow Account</button>
                </div>
              </div>
            </div>
          </div>
          <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadEscrowAccounts($event)"
            [value]="escrowAccounts" dataKey="id" styleClass="p-datatable-tasks" [rowHover]="true" [rows]="10"
            [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
            responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
            paginatorDropdownAppendTo="body"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="width:6rem">View/Edit</th>
                <th pSortableColumn="accountName">
                  <div class="flex justify-content-between align-items-center"
                    style="justify-content: flex-end;">
                    <span>Account Name</span>
                    <span style="display: flex; gap: 4px; align-items: center;">
                      <p-sortIcon field="accountName"></p-sortIcon>
                      <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                      type="text" field="accountName" display="menu"></p-columnFilter>
                    </span>
                  </div>
                </th>
                <th pSortableColumn="account">
                  <div class="flex justify-content-between align-items-center"
                    style="justify-content: flex-end;">
                    <span>Account</span>
                    <span style="display: flex; gap: 4px; align-items: center;">
                      <p-sortIcon field="account"></p-sortIcon>
                      <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                      type="text" field="account" display="menu"></p-columnFilter>
                    </span>
                  </div>
                </th>
                <th pSortableColumn="active">
                  <div class="flex justify-content-between align-items-center"
                    style="justify-content: flex-end;">
                    <span>Status</span>
                    <span style="display: flex; gap: 4px; align-items: center;">
                      <p-sortIcon field="active"></p-sortIcon>
                      <p-columnFilter matchMode="equals" [showOperator]="false" [showAddButton]="false"
                        type="text" field="active" display="menu">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-dropdown [ngModel]="value" [options]="statusList"
                            (onChange)="filter($event.value)" placeholder="Any">
                            <ng-template let-option pTemplate="item">
                              <span>{{option.label}}</span>
                            </ng-template>
                          </p-dropdown>
                        </ng-template>
                      </p-columnFilter>
                    </span>
                  </div>
                </th>
                <th pSortableColumn="createdBy">
                  <div class="flex justify-content-between align-items-center"
                    style="justify-content: flex-end;">
                    <span>Created By</span>
                    <span style="display: flex; gap: 4px; align-items: center;">
                      <p-sortIcon field="createdBy"></p-sortIcon>
                      <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                      type="text" field="createdBy" display="menu"></p-columnFilter>
                    </span>
                  </div>
                </th>
                <th pSortableColumn="createdOn">
                  <div class="flex justify-content-between align-items-center">
                    <span>Created On</span>
                    <p-sortIcon field="createdOn"></p-sortIcon>
                    <p-columnFilter #createdOnFilter type="date" field="createdOn" [showMatchModes]="false"
                      [showOperator]="false" [matchModeOptions]="matchModeOptionsDate"
                      [showAddButton]="false" display="menu" [showClearButton]="false"
                      [showApplyButton]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <div>
                          <p-dropdown [options]="matchModeOptionsDate"
                            (onChange)="onDateFilterChange('createdOn')"
                          [(ngModel)]="filterDatesMatchModes.createdOn"></p-dropdown>
                        </div>
                        <div>
                          @switch (filterDatesMatchModes.createdOn) {
                            @case ('betweenDate') {
                              <div>
                                <p-calendar [(ngModel)]="filterDates.createdOn"
                                  (onSelect)="onDateSelect('createdOn',$event)" [selectionMode]="'range'"
                                [readonlyInput]="true"></p-calendar>
                              </div>
                            }
                            @default {
                              <div>
                                <p-calendar [(ngModel)]="filterDates.createdOn" [selectionMode]="'single'"
                                [readonlyInput]="true"></p-calendar>
                              </div>
                            }
                          }
                        </div>
                        <div class="flex items-center" style="float:right">
                          <button type="button" style="margin:2%;" class="btn btn-primary"
                            pTooltip="Apply date filter" appActionTooltip
                          (click)="applyDatesFilter('createdOn');createdOnFilter.hide()">Apply</button>
                          <button type="button" style="margin:2%;" class="btn btn-danger"
                            pTooltip="Clear date filter" appActionTooltip
                          (click)="clearDatesFilter('createdOn');createdOnFilter.hide()">Clear</button>
                        </div>
                      </ng-template>
                    </p-columnFilter>
                  </div>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-account let-columns="columns">
              <tr>
                <td>
                  <div class="flex justify-content-between align-items-center"
                    style="gap: 8px; padding-left: 8px; padding-right: 8px;">
                    <button class="btn btn-info btn-sm" pTooltip="View escrow account" appActionTooltip
                      (click)="viewEscrowAccount(account)" role="button"><i
                    class="mdi mdi-eye"></i></button>
                    <span appActionTooltip
                      [pTooltip]="account.active !== 'Active' ? 'Only active escrow accounts can be edited' : 'Edit escrow account'"
                      [actionDisabled]="account.active !== 'Active'">
                      <button class="btn btn-warning btn-sm"
                        (click)="editEscrowAccount(account)" role="button"
                        [disabled]="account.active !== 'Active'"><i class="mdi mdi-pencil"></i></button>
                    </span>
                      <button class="btn btn-danger btn-sm" pTooltip="Activate or deactivate this escrow account" appActionTooltip
                        (click)="toggleEscrowStatus(account)" role="button">
                        <i class="mdi mdi-block-helper"></i>
                      </button>

                    </div>
                  </td>
                  @for (col of columns; track col) {
                    <td>
                      {{ account[col.field] }}
                    </td>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="cols.length + 1" class="text-center py-4">
                    No escrow accounts found.
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <p-dialog [resizable]="false" [draggable]="false" [(visible)]="escrowDialog" (onHide)="closeDialog()"
              [style]="{width: '60%'}" [header]="title" [modal]="true" styleClass="p-fluid">
              <ng-template pTemplate="content">
                <app-notification [errorMsg]="errorMsg"></app-notification>
                <form [formGroup]="escrowForm">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-5">
                          <div class="mb-3">
                            <label class="form-label"> Account Name <span
                            style="color:var(--al-danger);">*</span></label>
                            <input class="form-control" type="text" formControlName="accountName"
                              [disabled]="viewOnly" appSpellCheck>
                            @if (submitted && escrowForm.get('accountName')?.invalid) {
                              <span style="color:var(--al-danger)"
                                >Account Name
                              is required</span>
                            }
                          </div>
                        </div>
                        <div class="col-sm-5">
                          <div class="mb-3">
                            <label class="form-label">Account <span style="color:var(--al-danger);">*</span></label>
                            <input class="form-control" type="text" formControlName="account"
                              [disabled]="viewOnly" appSpellCheck>
                            @if (submitted && escrowForm.get('account')?.invalid) {
                              <span style="color:var(--al-danger)"
                                >Account is
                              required</span>
                            }
                          </div>
                        </div>
                        <div class="col-sm-1">
                          <div class="mb-3">
                            <label class="form-label">Status </label>
                            <input class="form-control" type="text" formControlName="active" disabled>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (!viewOnly) {
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="button-items" style="float: right;">
                          @if (newEscrow) {
                            <a class="btn btn-primary" (click)="saveEscrowAccount()" pTooltip="Save escrow account" appActionTooltip> Save @if (btnLoading) {
                              <i
                                style="margin-left: 7px;"
                              class="fa fa-solid fa-sync fa-spin"></i>
                            }</a>
                          }
                          @if (!newEscrow) {
                            <a class="btn btn-primary" (click)="saveEscrowAccount()" pTooltip="Update escrow account" appActionTooltip> Update @if (btnLoading) {
                              <i
                                style="margin-left: 7px;"
                              class="fa fa-solid fa-sync fa-spin"></i>
                            }</a>
                          }
                          <a class="btn btn-secondary" (click)="closeDialog()" pTooltip="Cancel and close" appActionTooltip> Cancel </a>
                        </div>
                      </div>
                    </div>
                  }
                </form>
              </ng-template>
            </p-dialog>
          </div>
        </div>
      </div>
